import { render, staticRenderFns } from "./GapPriority.vue?vue&type=template&id=12135f77&scoped=true&"
import script from "./GapPriority.vue?vue&type=script&lang=ts&"
export * from "./GapPriority.vue?vue&type=script&lang=ts&"
import style0 from "./GapPriority.vue?vue&type=style&index=0&id=12135f77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12135f77",
  null
  
)

export default component.exports